<script lang="ts">
  import DonationDetail from '../../components/employee/myDonations/DonationDetail.svelte';
  import { location } from 'svelte-spa-router';

  function idFromMyDonationPath(loc: string): string {
    const path = loc.split('?')[0];
    const prefix = '/my-donation/';
    if (!path.startsWith(prefix)) return '';
    return path.slice(prefix.length).split('/')[0] || '';
  }

  // Derive from the URL — more reliable than $params on browser back/forward.
  $: donationId = idFromMyDonationPath($location);
</script>

{#key donationId}
  {#if donationId}
    <DonationDetail {donationId} />
  {:else}
    <div style="padding: 2rem; text-align: center;">Loading donation details...</div>
  {/if}
{/key}
